import type { HowCarePlansWorkSlide as HowCarePlansWorkSlideType } from "@/types";
import { Heading } from "@/ui";

type HowCarePlansWorkSlideProps = {
  slide: HowCarePlansWorkSlideType;
};

export const HowCarePlansWorkSlide = ({
  slide: { description, id, imageUrl, title },
}: HowCarePlansWorkSlideProps) => {
  return (
    <div className="mr-8 flex w-full max-w-4xl flex-none flex-col rounded-lg bg-surface shadow-xs last:mr-0 sm:flex-row">
      <div className="flex flex-col gap-6 p-10">
        <div className="flex aspect-square w-14 items-center justify-center rounded-full bg-accent text-4xl font-extrabold text-accent-content">
          {id}
        </div>
        <div className="flex flex-col gap-2">
          <Heading level={4}>{title}</Heading>
          <p>{description}</p>
        </div>
      </div>
      <img
        alt={title}
        className="w-full flex-1 rounded-br-lg rounded-bl-lg object-cover sm:w-96 sm:rounded-tr-lg sm:rounded-bl-none"
        src={imageUrl}
      />
    </div>
  );
};
